import Component from '../Component';
import { fadeOut, fadeIn } from '@siteparts/show-hide-effects';
import * as uiStrings from '../../uiStrings';

class ZoomControl extends Component {
    constructor() {
        super();
        this.key = 'zoom';
    }

    render() {
        return `
            <div ref="component-${this.key}" class="zoom js-zoom">
                <div ref="zoom-in" class="zoom__in" title="${uiStrings.ZOOM_IN}">
                    <i class="fas fa-plus"></i>
                </div>
                <div ref="zoom-out" class="zoom__out" title="${uiStrings.ZOOM_OUT}">
                    <i class="fas fa-minus"></i>
                </div>
            </div>
        `;
    }

    hide() {
        fadeOut(this.component);
    }

    show() {
        fadeIn(this.component);
    }

    componentDidMount() {
        this.setupEventListeners();
    }

    setupEventListeners() {
        [this.refs['zoom-in'], this.refs['zoom-out']].forEach( elem => {
            elem.addEventListener('mousedown', () => {
                elem.classList.add('active');
            });

            elem.addEventListener('mouseup', () => {
                elem.classList.remove('active');
            });
        });

        this.refs['zoom-in'].addEventListener('click', () => {
            this.dispatchCustomEvent('zoom-in');
        });

        this.refs['zoom-out'].addEventListener('click', () => {
            this.dispatchCustomEvent('zoom-out');
        });
    }
}

export default ZoomControl;
